export const caseStudies = {
  'h3Customs': {
    id: 'h3-customs',
    title: 'H3 Customs',
    category: 'General Apparel',
    subtitle: 'From Scratch to $15K Monthly Revenue',
    video: 'https://www.youtube.com/embed/cVlor71pKpM',
    description: 'Transformed a new Amazon account with just two basic products into a thriving business through comprehensive optimization and strategic expansion.',
    stats: [
      {
        value: '3X',
        label: 'Sales Growth',
        description: 'Increased Sales within Short Period'
      },
      {
        value: '20%',
        label: 'ACOS',
        description: 'Maintain 20% and lower ACOS'
      },
      {
        value: '3k+',
        label: 'Listing Created',
        description: 'Expanded Product Range'
      },
      {
        value: '4.8',
        label: 'Rating',
        description: 'Average Product Rating'
      }
    ],
    challenges: [
      {
        title: 'Account Background and Initial State',
        description: 'The seller\'s Amazon account was just like a new account with little work done. It featured only two products—printed mouse pads and Kydex sheets—that were poorly optimized listings had unattractive images, and minimal descriptions, and lacked the necessary details to drive sales.'
      },
      {
        title: 'Lack of Advertising',
        description: 'There were no advertising campaigns in place to boost visibility. No PPC campaigns were running, which meant the listings were not being shown to the right audience. This lack of promotion contributed to the stagnant sales.'
      },
      {
        title: 'No Enhanced Brand Content (EBC)',
        description: 'The product listings lacked Enhanced Brand Content (EBC), which is essential for presenting products with rich media and detailed descriptions. Without it, the listings appeared basic and failed to capture customer attention effectively.'
      },
      {
        title: 'No Brand Store Setup',
        description: 'The seller had not set up a brand store on Amazon, missing the opportunity to showcase their products in a professional, cohesive manner. Without a brand store, customers had a harder time discovering more products from the same seller.'
      },
      {
        title: 'Need for a Solid Foundation',
        description: 'The main challenge was to turn the current products into profitable ones while laying the groundwork for future expansion. The seller needed proof of success from the existing products before expanding their product range.'
      }
    ],
    workDone: [
      {
        title: 'Market Research and Design Creation',
        description: 'We initiated market research to understand trending designs and customer preferences for current products. This research helped us identify popular styles, colors, and patterns in demand. Based on these insights, we created custom mouse pad designs that aligned with market trends and customer expectations.'
      },
      {
        title: 'Listing Optimization',
        description: 'The existing product listings were then optimized with catchy and easy-to-understand titles, bullet points, and detailed descriptions. We ensured that the product images were attractive and professionally designed to grab attention. High-quality images were used to highlight the design and features of the mouse pads, improving their visual appeal.'
      },
      {
        title: 'PPC Campaign Setup',
        description: 'We launched automatic PPC campaigns for the mouse pads to increase visibility and drive traffic. These campaigns gathered data for optimization, improving performance over time. We also created targeted keyword and product targeting campaigns to reach the right audience and boost competitiveness.'
      },
      {
        title: 'EBC to Brand Store Creation',
        description: 'To boost more sales, we added Enhanced Brand Content (A+ content) to all product listings and crafted a compelling brand story. We also created a professional brand store to showcase all products in one cohesive space, enhancing the customer shopping experience.'
      },
      {
        title: 'Sponsored Brand and Display',
        description: 'Once the brand store was live, we launched Sponsored Brand and Sponsored Display campaigns to increase brand visibility and generate more sales. These campaigns were aimed at promoting the brand and driving traffic to the brand store and individual product listings.'
      },
      {
        title: 'Addition of More Products',
        description: 'As a result of the initial success, the client expanded their product range to include printed mouse mats, dog mats, tumblers, hitch covers, and printed t-shirts. For each of these new products, we conducted thorough market research to identify trending designs and consumer demand. Each new product was carefully listed with optimized titles, descriptions, images, and targeted keywords.'
      },
      {
        title: 'Ongoing Product Research and Listing Creation',
        description: 'We continuously researched market trends and customer preferences to create optimized listings for new products. This approach kept the store fresh and aligned with demand. As a result, we grew sales from $0 to $15,000, earning the client\'s trust and fostering a long-term partnership.'
      }
    ],
    testimonial: {
      quote: "The transformation of our Amazon business has been remarkable. From basic listings to a thriving brand, the results speak for themselves.",
      author: "H3 Customs Team",
      position: "Amazon Seller"
    }
  },
  'galaxy-art': {
    title: 'Galaxy Art',
    subtitle: 'Drive 2X Sales of Seasonal Products in Off Season',
    category: 'Art & Crafts',
    duration: '6 months',
    stats: [
      {
        value: '2X',
        label: 'Growth',
        description: 'Sales increase in off-season'
      },
      {
        value: '80%',
        label: 'ROI',
        description: 'Return on Advertising Spend'
      },
      {
        value: '#12',
        label: 'Category Rank',
        description: 'In Main Product Category'
      },
      {
        value: '4.9',
        label: 'Rating',
        description: 'Average customer rating'
      }
    ],
    challenges: [
      {
        title: 'Seasonal Demand Peaks',
        description: 'These products experienced high demand only during festivals, leaving off-season sales stagnant and unpredictable.'
      },
      {
        title: 'Weak Listings',
        description: 'The product listings had basic images, no A+ content, and descriptions that failed to grab attention.'
      },
      {
        title: 'Ineffective PPC Ads',
        description: 'Poorly optimized listings led to underperforming ads, resulting in wasted advertising spend.'
      },
      {
        title: 'Limited Market Reach',
        description: 'Weak brand presence made it difficult to attract customers beyond the seasonal window.'
      },
      {
        title: 'Unclear Brand Identity',
        description: 'The brand wasn\'t able to effectively communicate its value proposition, making it hard for customers to see the product\'s full potential.'
      },
      {
        title: 'Low Conversion Rate',
        description: 'Unappealing product presentation and missed ad targeting led to low conversions.'
      }
    ],
    workDone: [
      {
        title: 'Listing Optimization',
        description: 'We recreate the product titles to include relevant keywords, improving search ranking. Product bullet points and descriptions were rewritten to clearly highlight the key benefits and engage customers.'
      },
      {
        title: 'Merged Variations',
        description: 'We listed similar designs under one parent listing to make browsing easier and create a more organized shopping experience.'
      },
      {
        title: 'Eye-Catching Images',
        description: 'We created high-quality, infographic and lifestyle product main images to make the products stand out and appeal to customers at first glance.'
      },
      {
        title: 'A+ Content & Brand Store',
        description: 'Design A+ content to described product in deep down and increase search visibility, while a dedicated brand storefront was designed to increase brand visibility and instil trust among shoppers.'
      },
      {
        title: 'PPC Campaign',
        description: 'Targeted Sponsored Product campaigns were launched to optimize ad spend, create new sponsored brand and sponsored display campaign and also started video ads to improve visibility, and drive more sales.'
      },
      {
        title: 'Off-Season Strategies',
        description: 'We introduced off-season promotions and targeted campaigns to keep sales consistent even during slower months.'
      },
      {
        title: 'Stronger Brand Presentation',
        description: 'We emphasized the versatility of the products, showing customers how they could be used for various occasions beyond just festivals, thus expanding the target market.'
      }
    ],
    results: [
      {
        value: '2X',
        label: 'Sales Growth',
        description: 'Increase in Monthly Revenue'
      },
      {
        value: '80%',
        label: 'ROI',
        description: 'Return on Advertising Spend'
      },
      {
        value: '#12',
        label: 'Category Rank',
        description: 'In Main Product Category'
      },
      {
        value: '4.8',
        label: 'Rating',
        description: 'Average Product Ratings'
      }
    ],
    testimonial: {
      quote: "We've seen a dramatic improvement in both our product rankings and sales. Their team is proactive, knowledgeable, and really understands the Amazon marketplace. I couldn't ask for a better partner to help manage my account.",
      author: "James Carter",
      position: "CEO, Galaxy Art"
    }
  },
  'gymish-lifestyle': {
    title: 'Gymish Lifestyle',
    subtitle: 'Achieved 100K Monthly Target',
    category: 'Fitness Apparel',
    duration: 'Ongoing',
    stats: [
      {
        value: '2.5X',
        label: 'Growth',
        description: 'Target Sales acheived'
      },
      {
        value: '100%',
        label: 'ROI',
        description: 'Return on Advertising Spend'
      },
      {
        value: '15%',
        label: 'ACOS',
        description: 'Maintain 15% and lower ACOS'
      },
      {
        value: '4.8',
        label: 'Rating',
        description: 'Average product rating'
      }
    ],
    challenges: [
      {
        title: 'Inventory and Listing Management',
        description: 'Missing product descriptions and bullet points caused our listings to lose visibility and failed to grab customer attention.'
      },
      {
        title: 'PPC Campaigns',
        description: 'Keeping our Advertising Cost of Sales (Acos) under 15% while pushing for higher sales was a constant struggle.'
      },
      {
        title: 'Listing Confusion',
        description: "Amazon's changing policies led to the separation of hoodies and tanks from the main t-shirt listings, causing confusion and requiring reorganization."
      },
      {
        title: 'Listing Merges',
        description: "Amazon's automatic merging of design listings made it difficult to keep product sizes and designs organized, leading to potential errors."
      },
      {
        title: 'Hijackers',
        description: 'The growing popularity of our brand attracted unauthorized sellers trying to hijack our listings with counterfeit products, threatening our brand integrity.'
      }
    ],
    workDone: [
      {
        title: 'Recreating and Enhancing Listings',
        description: 'We updated and recreated missing bullet points and descriptions, making sure each listing was clear, complete, and compelling. We also added A+ Content and a detailed Brand Story to build customer trust and enhance the listings.'
      },
      {
        title: 'Managing Listing Separations and Merges',
        description: 'We analyse the categories and created the listings to separate hoodies and tanks from the t-shirts, ensuring each category was organized with size variations. We also monitored and managed listings to prevent unwanted merges, ensuring they stayed accurate and live.'
      },
      {
        title: 'Protecting the Brand from Hijackers',
        description: 'We closely monitored the listings and quickly removed any unauthorized sellers to protect the integrity of the brand and sales.'
      },
      {
        title: 'Optimizing PPC Campaigns',
        description: 'We maintained the Acos under 15% while boosting sales. Our strategy focused on careful keyword selection, budget management, and regular campaign adjustments to maximize returns.'
      },
      {
        title: 'Creating New Listings',
        description: 'We created SEO-friendly listings for new products like tanks and hoodies, with high-quality images and A+ content designed to appeal to the target audience.'
      }
    ],
    testimonial: {
      quote: "I've tried managing PPC myself, but this team took it to the next level. Their insights and campaign management have drastically improved our sales, and we're spending less on ads to get more results. Couldn't be happier!",
      author: 'Vadim',
      position: 'Amazon Seller, Gymish Lifestyle'
    }
  },
  
};
